export default class Contact {
  constructor() {
    this.inputs = document.querySelectorAll('input, textarea');

    this.init();
  }

  init() {
    this.inputs.forEach((input) => {
      input.addEventListener('focus', (e) => this.handleFocus(e));
      input.addEventListener('blur', (e) => this.handleBlur(e));
    });
  }

  handleFocus(e) {
    const input = e.currentTarget;
    const labelText =
      input.parentElement.parentElement.querySelector('.label-text');
    if (labelText) {
      labelText.classList.add('open');
    }
  }

  handleBlur(e) {
    const input = e.currentTarget;
    const labelText =
      input.parentElement.parentElement.querySelector('.label-text');

    if (!input.value) {
      //has content
      labelText.classList.remove('open');
    }
  }
}
